class AddressRequestDTO {
	constructor({
        street,
        postalCode,
        number,
        complement,
        city,
        state,
        country,
        streetSecondary,
        postalCodeSecondary,
        numberSecondary,
        complementSecondary,
        citySecondary,
        stateSecondary,
        countrySecondary,
	}) {
		this.street = street;
		this.postalCode = postalCode;
		this.number = number;
		this.complement = complement;
		this.city = city;
		this.state = state;
		this.country = country;
		this.streetSecondary = streetSecondary;
		this.postalCodeSecondary = postalCodeSecondary;
		this.numberSecondary = numberSecondary;
		this.complementSecondary = complementSecondary;
		this.citySecondary = citySecondary;
		this.stateSecondary = stateSecondary;
		this.countrySecondary = countrySecondary;
	}
}

export default AddressRequestDTO;
